import './statusbutton.css';

export interface IStatusButtonsProps {
  filterButtonDate: {
    buttonLabel: string;
    currentSelection: string | undefined;
    handler: (value: string) => void;
    style: React.CSSProperties;
    labelData: {
      i_id: string;
      i_name: string;
      i_type: string;
      i_value: string;
      i_label: string;
      subclass?: string;
    }[];
  }[];
}

function StatusButtons({ filterButtonDate }: IStatusButtonsProps) {
  const getLabelForSelection = (selection: string | undefined, labelData: any[]) => {
    const foundItem = labelData.find((label) => label.i_value === selection);
    return foundItem ? foundItem.i_label : 'Не выбран';
  };

  return (
    <div className="statusbutton__container">
      {filterButtonDate.map((item, index) => (
        <div key={index} className="statusbutton__group">
          <div className="admin-filter__item" style={item.style}>
            <div className="filter__role">{item.buttonLabel}</div>
            <div className="filter__role__curr">{getLabelForSelection(item.currentSelection, item.labelData)}</div>
            <div className="filter__status__container">
              <div className="filter__status" style={{ height: 'fit-content', ...item.style }}>
                {item.labelData.map((label, idx) => (
                  <label
                    className={`dropdown-item ${item.currentSelection === label.i_value ? 'dropdown-item__active' : ''} ${label.subclass ? label.subclass : ''}`}
                    key={idx}
                  >
                    <input
                      id={label.i_id}
                      name={label.i_name}
                      type={label.i_type}
                      value={label.i_value}
                      checked={item.currentSelection === label.i_value}
                      onChange={() => item.handler(label.i_value)}
                    />
                    {label.i_label}
                  </label>
                ))}
                <button className="statusbutton__clear" onClick={() => item.handler('')}>
                  Сбросить выбор
                </button>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default StatusButtons;
